import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
} from '@mui/material';
import Select from '@mui/material/Select';
import AssetsDialog from './AssetsDialog';
import { visibleLanguages } from 'src/config/quill-text-editor-settings';
import { LocalizedDateTimePicker } from 'src/components/form/LocalizedDateTimePicker';
import Iconify from '../iconify';

const defaultState = {
  title: '',
  start_time: new Date().toISOString(),
  end_time: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
  is_visible: false,
  prize_image_en: null,
  tournament_type: 'WEEK',
};

interface LeagueTournamentDialogProps {
  open: boolean;
  tournament: any;
  onSuccessHandler: any;
  onClose: any;
}

export const LeagueTournamentDialog = (props: LeagueTournamentDialogProps) => {
  const [tournament, setTournament] = useState(defaultState);
  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (props.tournament === null) {
      setTournament(defaultState);
    }

    if (props.tournament !== null) {
      setTournament(props.tournament);
    }
  }, [props]);

  const handleChange = (e: any) => {
    const { id, value } = e.target;

    setTournament((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChangeIsVisible = (e: any) => {
    setTournament((prevState) => ({
      ...prevState,
      is_visible: e.target.checked,
    }));
  };

  const handleTournamentStartChange = (newValue: any) => {
    setTournament((prevState) => ({
      ...prevState,
      start_time: newValue,
    }));
  };

  const handleTournamentEndChange = (newValue: any) => {
    setTournament((prevState) => ({
      ...prevState,
      end_time: newValue,
    }));
  };

  const onSuccess = () => {
    setTournament(defaultState);
    props.onSuccessHandler(tournament);
  };

  const onCancel = () => {
    setTournament(defaultState);
    props.onClose();
  };

  const onChoseAsset = (assetUrl: string) => {
    setTournament((prevState) => ({
      ...prevState,
      [String(assetsTarget)]: assetUrl,
    }));
    setAssetsTarget(null);
  };

  const onCloseAssetsDialog = () => {
    setAssetsTarget(null);
  };

  const handleChangeType = (event: any) => {
    setTournament((prevState) => ({
      ...prevState,
      tournament_type: event.target.value,
    }));
  };

  const ImageGrid = ({ field, lang }: any) => (
    <Grid item xs={3}>
      <Box>Prize Banner {lang}</Box>
      {(tournament as any)[field] ? (
        <>
          <img
            style={{
              margin: '0 auto',
              width: 100,
              background: 'grey',
            }}
            alt=''
            src={(tournament as any)[field]}
          />
          <Iconify
            icon='eva:edit-outline'
            sx={{ width: 20, height: 20, cursor: 'pointer' }}
            onClick={() => setAssetsTarget(field)}
          />
        </>
      ) : (
        <Iconify
          icon='eva:plus-circle-outline'
          sx={{
            width: 20,
            height: 20,
            cursor: 'pointer',
            marginTop: 2,
            marginBottom: 2,
          }}
          onClick={() => setAssetsTarget(field)}
        />
      )}
    </Grid>
  );
  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            Create League Tournament
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id='title'
                  label='Title'
                  fullWidth
                  value={tournament.title}
                  variant='standard'
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizedDateTimePicker
                  label='Start'
                  value={tournament.start_time}
                  onChange={handleTournamentStartChange}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizedDateTimePicker
                  label='End'
                  value={tournament.end_time}
                  onChange={handleTournamentEndChange}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tournament.is_visible ?? false}
                      onChange={handleChangeIsVisible}
                      id='is_visible'
                    />
                  }
                  label='Is Visible'
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id='type-select-label'>Type</InputLabel>
                  <Select
                    labelId='type-label'
                    id='type-select'
                    value={tournament.tournament_type ?? 'WEEK'}
                    label='Type'
                    onChange={handleChangeType}
                  >
                    <MenuItem value='WEEK'>WEEK</MenuItem>
                    <MenuItem value='MONTH'>MONTH</MenuItem>
                    <MenuItem value='SEASON'>SEASON</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {visibleLanguages.map((lang) => (
                <ImageGrid
                  key={lang.code}
                  field={`prize_image_${lang.code}`}
                  lang={lang.code.toUpperCase()}
                />
              ))}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={
                !tournament.title ||
                !tournament.start_time ||
                !tournament.end_time ||
                !tournament.prize_image_en
              }
            >
              {props.tournament === null ? 'Create' : 'Edit'}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
};
